import React, { FC, useEffect, useState, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchaseOrderLogModel } from "../purchaseOrderLogModel";
import { IVRMPurchaseOrderLogDetail } from "../purchaseOrderLogService";
import { formatNum } from "@/utils/utils";
import { useDictModel } from "@/views/base/dict/dictModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = usePurchaseOrderLogModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData();
    }, [])

    const defaultColumns: ColumnsType<IVRMPurchaseOrderLogDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '申请单位',
            width: 110,
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: '110px' }} />,
        }, {
            title: '申请日期',
            width: 100,
            dataIndex: 'fillingTime',
        }, {
            title: '审批日期',
            width: 100,
            dataIndex: 'approvalTime',
        }, {
            title: '下订单日期',
            width: 100,
            dataIndex: 'createTime',
        }, {
            title: '采购批次',
            width: 160,
            dataIndex: 'batchCode',
        }, {
            title: '供货单位',
            width: 160,
            dataIndex: 'supplierName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '材料编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '材料大类',
            width: 160,
            dataIndex: 'ptypeName',
        }, {
            title: '材料小类',
            width: 100,
            dataIndex: 'typeName',
        }, {
            title: '材料名称',
            width: 140,
            dataIndex: 'materialName',
        }, {
            title: '品牌',
            width: 110,
            dataIndex: 'brandName',
            render: (text: any) => <YhTootip text={text} style={{ width: '110px' }} />,
        }, {
            title: '适用车型',
            width: 150,
            dataIndex: 'vehicleModel',
            render: (text: any) => <YhTootip text={text} style={{ width: '150px' }} />,

        }, {
            title: '规格、型号',
            width: 200,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '计量单位(采购)',
            width: 120,
            dataIndex: 'unitName',
        }, {
            title: '采购数量',
            width: 110,
            dataIndex: 'planNum',
        }, {
            title: '采购单价(含税)',
            width: 130,
            dataIndex: 'price',
        }, {
            title: '采购总价(含税)',
            width: 130,
            dataIndex: 'amount',
        }, {
            title: '收货日期',
            width: 160,
            dataIndex: 'arrivedTime',
        }, {
            title: '专票发票税额',
            width: 130,
            dataIndex: 'tax',
        }, {
            title: '成本总价(不含税)',
            width: 130,
            dataIndex: 'totalCost',

        }, {
            title: '成本单价(不含税)',
            width: 130,
            dataIndex: 'costPrice',

        }, {
            title: '采购到货数量',
            width: 120,
            dataIndex: 'arrivedTotal',
        }, {
            title: '未到货数量',
            width: 120,
            dataIndex: 'unarrivedNum',
        }, {
            title: '退货数量',
            width: 120,
            dataIndex: 'preturnNum',
        }, {
            title: '备注(库房专用)',
            width: 200,
            dataIndex: 'note',
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "orderDetailStatic", "roleCodes": roles };
        return getRoleColumns("orderDetailStatic", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowClassName={(record) => record.deleteFlag == 1 ? "editable-row yh-edit-table-tr strikethroughOrange" : 'editable-row yh-edit-table-tr'}
            rowKey={record => record.id}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 340px)' }}
        />
    )
}